import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-radio-button", () => {
    it("emits the correct event", async () => {
        const page = await newE2EPage();
        await page.setContent(`
        <ux-form-group required label="radio buttons">
            <ux-radio-button
                label="Radio Button Label"
                value="1"
                name="input"
                input-id="1"
            ></ux-radio-button>
            <ux-radio-button
                label="Radio Button Label"
                value="2"
                name="input"
                input-id="2"
            ></ux-radio-button>
        </ux-form-group>
        `);
        const uxRadioButton1 = await page.find("ux-radio-button[value='1']");
        const uxRadioButton2 = await page.find("ux-radio-button[value='2']");
        const radioButtonLabel1 = await uxRadioButton1.find("label");
        const tadioButtonLabel2 = await uxRadioButton2.find("label");
        const eventHandler = await page.spyOnEvent("uxRadioButtonChange");
        expect(uxRadioButton1).toHaveClass("hydrated");
        expect(uxRadioButton2).toHaveClass("hydrated");
        await radioButtonLabel1.click();
        await page.waitForChanges();
        expect(eventHandler).toHaveReceivedEventDetail({
            checked: true,
            inputId: "1",
            name: "input",
            value: "1",
        });
        let radioButton1 = await uxRadioButton1.findAll("input:checked");
        let radioButton2 = await uxRadioButton2.findAll("input:checked");
        expect(radioButton1.length).toBe(1);
        expect(radioButton2.length).toBe(0);
        await tadioButtonLabel2.click();
        await page.waitForChanges();
        expect(eventHandler).toHaveReceivedEventDetail({
            checked: true,
            inputId: "2",
            name: "input",
            value: "2",
        });
        radioButton1 = await uxRadioButton1.findAll("input:checked");
        radioButton2 = await uxRadioButton2.findAll("input:checked");
        expect(radioButton1.length).toBe(0);
        expect(radioButton2.length).toBe(1);
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-radio-button></ux-radio-button>`);
        const el = await page.find("ux-radio-button");
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-radio-button></ux-radio-button>`);
    });
});
